import { CalcularDeudaTotal, CalculoCuota } from "../../../functions/FunctionCuota";
import { CreditoDetalles } from "../../../functions/Validaciones/CreditoDetalles";
import { CuotasDetalle } from "../../../functions/Validaciones/CuotasDetalle";
import { tipoConcesion } from "../../shared/Helpers/CalculosConcesiones";
import "../../shared/styles/UnifiedTable.css";

const Tabla_creditos = ({ data, onClick, onChange }) => {
  //Calcular cuotas
  const cuotas = (cuotas) => {
    let result = [];

    cuotas.map((cuota) => {
      let re = CalculoCuota(cuota);
      result.push(re);
    })

    return result;
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="unified-table-container" style={{ maxHeight: "600px", overflowY: "auto" }}>
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div>Nº</div></th>
            <th className="text-start"><div>Producto</div></th>
            <th className="text-center"><div>Estado</div></th>
            <th className="text-end"><div>Monto</div></th>
            <th className="text-center"><div>Cuotas</div></th>
            <th className="text-center"><div>Pagas</div></th>
            <th className="text-center"><div>Vencidas</div></th>
            <th className="text-end"><div>Deuda</div></th>
            <th className="text-center"><div>Concesión</div></th>
            <th className="text-center"><div>Resumen</div></th>
            <th className="text-center"><div>Pagar</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((credito) => {
            const getEstadoBadge = (estado) => {
              const estados = {
                'Vigente': 'unified-badge-success',
                'No Vigente': 'unified-badge-warning',
                'Eliminado': 'unified-badge-danger',
                'Cancelado': 'unified-badge-secondary',
                'Pagado': 'unified-badge-info'
              };
              return estados[estado] || 'unified-badge-secondary';
            };

            return (
            <tr key={credito.id}>
              <td className="text-center">{credito.id}</td>
              <td className="text-start">{credito.producto}</td>
              <td className="text-center">
                <span className={`unified-badge ${getEstadoBadge(credito.estado)}`}>
                  {credito.estado || 'Sin estado'}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  $ {formatCurrency(credito.monto)}
                </span>
              </td>
              <td className="text-center">{credito.detalles.length}</td>
              <td className="text-center">
                {CuotasDetalle(credito.detalles, credito.concesion).pagas}
              </td>
              <td className="text-center">
                {CuotasDetalle(credito.detalles, credito.concesion).vencidas}
              </td>
              <td className="text-end">
                <span className="unified-money">
                  $ {formatCurrency(CalcularDeudaTotal(0, cuotas(CreditoDetalles(credito).detalles)))}
                </span>
              </td>
              <td className="text-center">
                {tipoConcesion(credito.concesion ? credito.concesion.id_tipoconcesion : "")}
              </td>
              <td className="text-center">
                <button
                  className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                    color: '#ffffff',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    border: 'none',
                    fontWeight: '500'
                  }}
                  name="resumen"
                  data-bs-toggle="modal"
                  data-bs-target="#resumen-credito"
                  onClick={(event) => onClick(event, credito)}
                >
                  <i className="bi bi-card-checklist me-2"></i>
                  Resumen
                </button>
              </td>
              <td className="text-center">
                {credito.estado !== 'Eliminado' && (
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '8px 16px',
                      border: 'none',
                      fontWeight: '500'
                    }}
                    name="credito"
                    onClick={(event) => onClick(event, credito)}
                  >
                    <i className="bi bi-plus-circle me-2"></i>
                    Pagar
                  </button>
                )}
              </td>
            </tr>
            );
          })}
        </tbody>
        <tfoot></tfoot>
      </table>
    </div>
  );
};

export default Tabla_creditos;
